module.exports = __webpack_public_path__ + "img/plus_d6.43a0e20b.png";